import { Button, Divider, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useAppDispatch } from '../../../../appStore';
import { IAudience } from '../../../../models';
import { IApplicationState } from '../../../../store';
import { loadPendingParticipants, savePendingParticipants } from '../../../../store/PendingParticipantsSlice';
import { SectionHeaderMedium } from '../../../common/styles/globalStyles';
import { AudienceParticipantsTable } from './AudienceParticipantsTable';

const PulloutContainer = styled.div`
	margin: auto;
	margin-bottom: 30px;
	width: 50%;
`;
PulloutContainer.displayName = 'PulloutContainer';
const SectionContainer = styled.div`
	margin-bottom: 40px;
`;
SectionContainer.displayName = 'SectionContainer';
const Content = styled.div`
	width: 100%;
`;
const LeftContent = styled.div`
	display: inline-block;
	vertical-align: top;
`;
LeftContent.displayName = 'LeftContent';

const RightContent = styled.div`
	display: inline-block;
	text-align: right;
	vertical-align: top;
`;
RightContent.displayName = 'RightContent';

export interface IAudienceParticipantsSectionProps {
	surveyId: number;
	audiences: IAudience[];
}

export const AudienceParticipantsSection = (props: IAudienceParticipantsSectionProps) => {
	const { pendingParticipants, status } = useSelector((state: IApplicationState) => state.pendingParticipants);
	const { surveyId } = props;
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(loadPendingParticipants(surveyId));
	}, [surveyId, dispatch]);

	const participantsWithAccessCode = pendingParticipants.filter((p) => p.accessCode !== undefined && p.accessCode.trim() !== '');

	if (pendingParticipants?.length > 0) {
		return (
			<SectionContainer>
				<PulloutContainer>
					<Pullout type={PulloutType.Warning}>
						<strong>New Participants Detected: </strong>There are new participants detected in Org Manager
					</Pullout>
				</PulloutContainer>
				<Content>
					<LeftContent className='col-lg-8 col-sm-12'>
						<SectionHeaderMedium>Participants</SectionHeaderMedium>
					</LeftContent>
					<RightContent className='col-lg-4 col-sm-12'>
						<Button
							color='secondary'
							disabled={participantsWithAccessCode.length === 0 || status === 'saving'}
							onClick={() => dispatch(savePendingParticipants({ surveyId, contacts: participantsWithAccessCode }))}
						>
							Assign to Audience
						</Button>
					</RightContent>
				</Content>
				<AudienceParticipantsTable participants={pendingParticipants} audiences={props.audiences} />
				<Divider type='dashed' />
			</SectionContainer>
		);
	} else {
		return <></>;
	}
};
